import { ProgressBar } from "processhub-components-lib";
import useScreen from "hooks/useScreen";

const OverallProgress = () => {
  const { isScaled } = useScreen();
  return (
    <div className="flex flex-wrap items-center justify-center">
      <h3>Overall Progress: 44%</h3>
      <div className="w-full">
        <ProgressBar value={44} className="h-[20px]" hasValueDisplay={false} height={isScaled ? 10 : 15} />
      </div>
    </div>
  );
};

export default OverallProgress;